import script from "./infotainment_card.vue?vue&type=script&setup=true&lang=js"
export * from "./infotainment_card.vue?vue&type=script&setup=true&lang=js"

import "./infotainment_card.vue?vue&type=style&index=0&id=e96c3304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e96c3304"]])

export default __exports__